import { render } from "./SelectionPopover.vue?vue&type=template&id=33825a04&scoped=true"
import script from "./SelectionPopover.vue?vue&type=script&lang=js"
export * from "./SelectionPopover.vue?vue&type=script&lang=js"

import "./SelectionPopover.vue?vue&type=style&index=0&id=33825a04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33825a04"]])

export default __exports__